export default __webpack_public_path__ + "static/media/délais_paiement.2a8082db.png";